export const isNonHttpError = (error) => !(error.response?.status || error.code === 'ECONNABORTED' || error.message === 'Network Error');
